'use strict';

import { observable, action, configure, makeObservable } from "mobx";
configure({enforceActions: 'always'});

import {States} from "@uw-it-sis/lib-react/lib/AppConstants";
import events from "@uw-it-sis/lib-react/lib/Events";
import {ScheduleBuilderEvents} from "./ScheduleBuilderConstants";
import scheduleBuilderOptionsStore from "./ScheduleBuilderOptionsStore";

class PinnedScheduleOptionStore {

    state = States.initial;

    showSchedule = false;

    constructor() {
        makeObservable(this, {
            state: observable,
            showSchedule: observable,
            mount: action,
            _setShowSchedule: action,
            toggleShowSchedule: action
        });

        this.scheduleData = {};
    }

    mount(scheduleData) {

        this.state = States.pending;
        this.scheduleData = scheduleData;

        this.showSchedule = scheduleBuilderOptionsStore.isScheduleShown(this.scheduleData.activityHash);

        this.scheduleDisplayToggledListener = (eventObj) => {
            if (
                this.scheduleData.activityHash === eventObj.activityHash
                &&
                this.showSchedule !== eventObj.shown
            ) {
                this.showSchedule = eventObj.shown
            }
        }

        events.listen(ScheduleBuilderEvents.scheduleDisplayToggled, (eventObj) => {
            this.scheduleDisplayToggledListener(eventObj);
        });

        this.scheduleOptionsLoadedListener = () => {
            if (this.showSchedule) {
                // if the loaded schedule options are empty, disable the show state and don't attempt to toggle
                if (scheduleBuilderOptionsStore.schedules.possibleSchedules.length === 0) {
                    this._setShowSchedule(false);
                }
                else {
                    scheduleBuilderOptionsStore.toggleDisplayedSchedule(true, this.scheduleData);
                }
            }
        }

        events.listen(ScheduleBuilderEvents.scheduleOptionsLoaded, () => this.scheduleOptionsLoadedListener());

        this.state = States.done;

    }

    unmount() {
        events.remove(ScheduleBuilderEvents.scheduleDisplayToggled, (eventObj) => {
            this.scheduleDisplayToggledListener(eventObj);
        });

        events.remove(ScheduleBuilderEvents.scheduleOptionsLoaded, () => this.scheduleOptionsLoadedListener());
    }

    _setShowSchedule(newValue) {
        this.showSchedule = newValue
    }


    toggleShowSchedule(newValue) {
        this._setShowSchedule(newValue);
        scheduleBuilderOptionsStore.toggleDisplayedSchedule(this.showSchedule, this.scheduleData);
    }

}

export default PinnedScheduleOptionStore;